module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "reports"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Overview")]), _vm._v(" "), _c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1), _vm._v(" "), (_vm.reportData) ? _c('div', {
    staticClass: "p-30"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.order_details) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Order statistics")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'order_details',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('order_details')
      }
    }
  }, [(_vm.showDetailChart()) ? _c('chart-bar-and-line', {
    attrs: {
      "data": _vm.getOrderDetailsData
    }
  }) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("No data available.")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.subscription_data) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("General statistics")]), _vm._v(" "), _c('el-card', {
    staticClass: "mb-10",
    attrs: {
      "shadow": "none"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("\n                                " + _vm._s(_vm.reportData.subscription_data.all_orders) + "\n                            ")]), _vm._v("\n                            Orders\n                        ")]), _vm._v(" "), _c('el-col', {
    staticClass: "text-center",
    attrs: {
      "sm": 12
    }
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("\n                                " + _vm._s(_vm.reportData.subscription_data
    .products_sold) + "\n                            ")]), _vm._v("\n                            Products\n                        ")])], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm.reportData.subscription_data.status))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Shop status")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm.reportData.subscription_data.products_count))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Products in total")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.reportData.subscription_data.total,
    _vm.reportData.subscription_data
    .currency
  )))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Total orders")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.reportData.subscription_data.paid_orders,
    _vm.reportData.subscription_data
    .currency
  )))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Orders paid")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "text-right text-highlight",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.reportData.subscription_data.tickets || 0),
    _vm.reportData.subscription_data
    .currency
  )) + "\n                        ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_vm._v("Average total")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reportData.best_sellers) ? _c('div', {
    staticClass: "mb-50"
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Best selling products")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'best_seller',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('best_seller')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.getBestsellerData.values.length > 0) ? _c('chart-pie', {
    attrs: {
      "data": _vm.getBestsellerData
    }
  }) : _c('div', {
    staticClass: "text-gray"
  }, [_vm._v("\n                            No data available.\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.reportData.best_sellers.length > 0) ? _c('table', {
    staticClass: "w-full"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left px-12"
  }, [_vm._v("Top 5")]), _vm._v(" "), _c('th', {
    staticClass: "text-right px-12"
  }, [_vm._v("\n                                        Quantity\n                                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportData.best_sellers), function(bestseller, i) {
    return (i < 5) ? _c('tr', [_c('td', [_vm._v("\n                                        " + _vm._s(bestseller.sku) + " -\n                                        " + _vm._s(bestseller.name) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                                        " + _vm._s(bestseller.quantity) + "\n                                    ")])]) : _vm._e()
  }), 0)]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.new_vs_recurring_orders) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("New x Existing customers")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'returning_visitors',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('returning_visitors')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.new_vs_recurring_orders[1].orders,
      "value2": _vm.reportData.new_vs_recurring_orders[0].orders,
      "description1": _vm.reportData.new_vs_recurring_orders[1].type,
      "description2": _vm.reportData.new_vs_recurring_orders[0].type
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.gender_based_orders) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Male x Female")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'gender',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('gender')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.gender_based_orders[0]
        .number_of_orders,
      "value2": _vm.reportData.gender_based_orders[1]
        .number_of_orders,
      "description1": _vm.reportData.gender_based_orders[0].gender,
      "description2": _vm.reportData.gender_based_orders[1].gender
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.reportData.abandoned_vs_completed) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Aborted x Completed")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin',
        params: {
          model: 'report',
          id: 'abandoned',
          action: 'all',
        },
      }
    }
  }, [_vm._v("Detailed statistics »")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "cursor-pointer",
    attrs: {
      "shadow": "hover"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToDetail('abandoned')
      }
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.abandoned_vs_completed[1]
        .orders_number,
      "value2": _vm.reportData.abandoned_vs_completed[0]
        .orders_number,
      "description1": _vm.reportData.abandoned_vs_completed[1].type,
      "description2": _vm.reportData.abandoned_vs_completed[0].type
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.get_in_vs_out_of_stock) ? _c('el-col', {
    staticClass: "mb-50",
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "gutter": 10,
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12
    }
  }, [_c('h3', [_vm._v("Orders without stock")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "sm": 12
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('chart-progress', {
    attrs: {
      "value1": _vm.reportData.get_in_vs_out_of_stock[1]
        .number_of_products,
      "value2": _vm.reportData.get_in_vs_out_of_stock[0]
        .number_of_products,
      "description1": _vm.reportData.get_in_vs_out_of_stock[1].type,
      "description2": _vm.reportData.get_in_vs_out_of_stock[0].type
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbf25dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
// module id = 547
// module chunks = 1